export default __webpack_public_path__ + "static/media/CarImages.KigerGallery1.16ffd3fa.jpg";